var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"height":_vm.height,"label":_vm.$t('请输入审批意见'),"clearable":true,"solo":"","rows":"30"},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})
}
var staticRenderFns = []

export { render, staticRenderFns }